import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './FloatingContactHub.css';

const CALLOUT_KEY = `conciergeCalloutDismissed_${SITE_CONFIG.SITE_ID}`;

const getVisitorName = () => {
  for (const key of ['leadInfo', 'user']) {
    try {
      const value = JSON.parse(localStorage.getItem(key) || 'null');
      const name = value?.name || value?.username || value?.fullName;
      if (name) return String(name).trim().split(/\s+/)[0];
    } catch (error) {
      // Ignore malformed or unavailable browser storage.
    }
  }
  return '';
};

const FloatingContactHub = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const visitorName = useMemo(getVisitorName, [pathname]);
  const [showCallout, setShowCallout] = useState(false);
  const isAdmin = pathname.startsWith('/admin');
  const isChat = pathname === '/chat';
  const isAboutPeter = pathname === '/agent';

  useEffect(() => {
    if (isAdmin || isChat || isAboutPeter || sessionStorage.getItem(CALLOUT_KEY) === 'true') return undefined;
    const timer = window.setTimeout(() => setShowCallout(true), 7000);
    return () => window.clearTimeout(timer);
  }, [isAdmin, isChat, isAboutPeter, pathname]);

  if (isAdmin || isAboutPeter) return null;

  const dismissCallout = () => {
    sessionStorage.setItem(CALLOUT_KEY, 'true');
    setShowCallout(false);
  };

  const control = (
    <div className="floating-contact-hub" aria-label="Contact Integritos Real Estate">
      {!isChat && showCallout && (
        <div className="concierge-callout" role="status">
          <button type="button" className="concierge-callout-dismiss" onClick={dismissCallout} aria-label="Dismiss concierge greeting">×</button>
          <button type="button" className="concierge-callout-open" onClick={() => navigate('/chat')} aria-label="Start a conversation with Peter's AI assistant">
            <strong>{visitorName ? `Hi ${visitorName}—` : 'Hello—'} what can I help you find?</strong>
            <span>Search homes, plan a sale, create an alert, or ask a South Florida real estate question.</span>
          </button>
        </div>
      )}

      {!isChat && (
        <button
          type="button"
          className="floating-concierge-button"
          onClick={() => navigate('/chat')}
          aria-label="Open the Integritos AI Concierge"
        >
          <span aria-hidden="true">✦</span>
          <span><strong>AI Concierge</strong><small>Ask anything</small></span>
        </button>
      )}
    </div>
  );
  return control;
};

export default FloatingContactHub;
